import IconCross from 'images/icons/IconCross';
import styled, { css } from 'styled-components';

export const GeneralModalWindow = styled.div`
  position: relative;
  padding: 16px;

  @media screen and (min-width: 768px) {
    padding: 24px;
  }
  background-color: ${({ theme }) => theme.color.mainColor1};
`;

export const StyledIconCross = styled(IconCross)`
  @media screen and (max-width: 427.5px) {
    width: 5.6vw;
    height: 5.6vw;
  }
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  stroke: ${({ theme }) => theme.color.mainColor3};
  fill: ${({ theme }) => theme.color.mainColor3};
  z-index: 1;
`;

export const StyledIconCrossToWindow = styled(IconCross)`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  @media screen and (min-width: 768px) {
    top: 24px;
    right: 24px;
  }
`;

export const ModalTitle = styled.h2`
  text-align: center;
  font-family: 'Open Sans Hebrew', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.02px;

  color: ${({ theme }) => theme.color.mainColor5};
`;

export const TextDescription = styled.p`
  @media screen and (max-width: 427.5px) {
    max-width: 46.7vw;
  }
  font-family: 'Open Sans Hebrew', sans-serif;
  font-size: 14px;
  margin-top: 0;
  text-align: center;
  font-weight: 700;
  line-height: 1.43;
  max-width: 200px;

  color: ${({ theme }) => theme.color.mainColor5};
`;

export const TextDone = styled.p`
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  padding: 56px 24px 32px;
  overflow-wrap: anywhere;
  text-align: center;
  font-family: Open Sans, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.mainColor5};

  @media screen and (min-width: 768px) {
    padding: 56px 32px 40px;
    font-size: 18px;
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(97, 97, 97, 0.6);
  backdrop-filter: blur(4px);
  z-index: 1200;
`;
export const ModalContainer = styled.div`
  box-sizing: border-box;
  min-width: 0;
  max-inline-size: calc(100vw - 32px);
  position: relative;
  background-color: ${({ theme }) => theme.color.mainColor1};
  margin: auto;
  max-width: 360px;
  border-radius: 2px;
  z-index: 2000;
  height: max-content;

  @media screen and (min-width: 768px) {
    max-width: 448px;
    /* height: 326px; */
  }
  @media screen and (min-width: 1440px) {
    max-width: 920px;
    /* height: 326px; */
  }
  ${({ $authModal }) =>
    $authModal &&
    css`
      width: 100%;
      max-width: 992px;
      min-width: 0;
      flex-shrink: 0;
      @media (min-width: 768px) {
        max-width: 992px;
      }
      @media (min-width: 1440px) {
        max-width: 992px;
      }
    `}
`;
export const BtnStyled = styled.button`
  cursor: pointer;
  border: none;
  margin-left: auto;
  padding: 0;

  background-color: transparent;
`;

export const ModalDescription = styled.p`
  text-align: center;
  font-family:
    Open Sans,
    sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.02px;

  color: ${({ theme }) => theme.color.mainColor5};
`;

export const ModalWindow = styled.div`
  @media screen and (max-width: 427.5px) {
    width: 84vw;
    padding: 3.7vw;
  }
  box-sizing: border-box;
  /* ${({ width }) => `width: ${width};`} */
  width: 360px;
  display: flex;
  padding: 16px;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  position: relative;
  @media screen and (min-width: 768px) {
    padding: 24px;
    gap: 24px;
    width: 448px;
  }

  background-color: ${({ theme }) => theme.color.mainColor1};
`;

export const LabelModal = styled.label`
  @media screen and (max-width: 427.5px) {
    width: 93.5vw;
  }
  width: 400px;
  font-family: 'Open Sans Hebrew', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.43;
  display: flex;
  flex-direction: column;

  color: ${({ theme }) => theme.color.mainColor5};
`;

export const InputModal = styled.input`
  font-family: 'Open Sans Hebrew', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.43;
  border-radius: 2px;
  border: 1px solid;
  padding: 8px;
  outline: none;

  border-color: ${({ theme }) => theme.color.mainColor2};
  color: ${({ theme }) => theme.color.mainColor2};
  &::placeholder {
    color: ${({ theme }) => theme.color.lightBGColor};
  }
`;

export const ScrollBox = styled.div`
  overflow: auto;

  box-sizing: border-box;
  height: 100vh;
  width: 100vw;

  display: flex;
  ${({ $authModal }) =>
    $authModal &&
    css`
      height: 100dvh;
      width: 100%;
      padding: max(16px, env(safe-area-inset-top))
        max(16px, env(safe-area-inset-right))
        max(16px, env(safe-area-inset-bottom))
        max(16px, env(safe-area-inset-left));
      overscroll-behavior: contain;
    `}
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.color.additionalColorRed};

  font-family: 'Open Sans, sans-serif';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`;

export const CloseButton = styled.button`
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  z-index: 5;
  & svg { position: static; width: 24px; height: 24px; }
  &:focus-visible { outline: 2px solid #77695e; outline-offset: 2px; }
  @media screen and (max-width: 427.5px) {
    top: 1.9vw;
    right: 1.9vw;
  }
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  position: absolute;
  top: 4px;
  right: 4px;
  ${({ $authModal }) =>
    $authModal &&
    css`
      width: 44px;
      height: 44px;
      top: 4px;
      right: 4px;
      z-index: 5;
      background: rgba(255, 255, 255, 0.94);
      border-radius: 2px;
      display: grid;
      place-items: center;
      &:focus-visible {
        outline: 2px solid #77695e;
        outline-offset: 2px;
      }
      & svg {
        position: static;
        width: 24px;
        height: 24px;
      }
    `}
`;
